// ─── UI Text ──────────────────────────────────────────────────────────────────

export const TEXT = {
  PAGE_TITLE: "Group",
  PAGE_SUBTITLE:
    "Multiple businesses, multiple locations, multiple functions, multiple job-grades, multiple roles, multiple employees.",

  TAB_JOBS_LIBRARY: "Jobs Library",
  TAB_SKILLS_BRIDGER: "Skills Bridger",
  TAB_SKILLS_PROFICIENCY: "Skills Proficiency",
  TAB_SKILLS_MAP: "Skills Map",
  TAB_LEARNING_CATALYST: "Learning Catalyst",
  TAB_TALENT_MOBILITY: "Talent Mobility",

  COL_SKILL_NAME: "Skill Name",

  // Group page column titles
  COL_INFERRED_PROFICIENCY: "Inferred Proficiency",
  COL_PRIORITY_SKILLS: "Priority Skills To Develop",

  // Employee page column titles
  COL_CURRENT_AND_REQUIRED: "Current and Required Proficiency",
  COL_PRIORITY_SKILL_FOR_ROLE: "Priority Skill For Role",

  COL_PROFICIENCY_SCALE: "(0-5 Scale)",
  COL_CURRENT_LABEL: "Current Proficiency",
  COL_REQUIRED_LABEL: "Required Proficiency",
  COL_REQUIRED_HINT: "(change using + and - buttons)",

  SCALE_HEADING: "Skills Proficiency Scale",
  SCALE_SEPARATOR: " : ",
  BTN_VIEW_DETAILS: "View Details",

  PAGINATION_SHOWING: "Showing",
  PAGINATION_ITEMS_PER_PAGE: "Items per page",

  WARNING_TITLE: "Change required skills proficiency?",
  WARNING_BODY:
    "Changing the required proficiency will update the target for all employees in this group. Are you sure you want to proceed?",
  WARNING_OK: "Change",
  WARNING_CANCEL: "Cancel",

  SCALE_MODAL_TITLE: "Skills Proficiency Scale",
  SCALE_MODAL_CLOSE: "Hide Details",

  CONDITIONAL_ALERT_TITLE: "Restricted Action",
  CONDITIONAL_ALERT_MSG:
    "You can only change a group if all employees share the same role, function, business unit, and location.",
  CONDITIONAL_ALERT_OK: "OK",
};

// ─── Tab Keys ─────────────────────────────────────────────────────────────────

export const TAB_KEYS = {
  JOBS_LIBRARY: "jobs-library",
  SKILLS_BRIDGER: "skills-bridger",
  LEARNING_CATALYST: "learning-catalyst",
  TALENT_MOBILITY: "talent-mobility",
};

// ─── Coming Soon Tabs ─────────────────────────────────────────────────────────
// Set used for O(1) membership check; these tabs show a placeholder instead of content.

export const COMING_SOON_TABS = new Set([
  TAB_KEYS.JOBS_LIBRARY,
  TAB_KEYS.LEARNING_CATALYST,
  TAB_KEYS.TALENT_MOBILITY,
]);

// ─── Skills Bridger Dropdown ──────────────────────────────────────────────────

export const SKILLS_BRIDGER_DROPDOWN_ITEMS = [
  { key: "skills-proficiency", label: TEXT.TAB_SKILLS_PROFICIENCY },
];

// ─── Route Paths ──────────────────────────────────────────────────────────────

export const ROUTES = {
  SKILLS_BRIDGER: "/Skills-bridger",
  GROUP_SKILLS_MAP: "/skills-bridger/group-skills-map",
  EMPLOYEE_SKILLS_MAP: "/skills-bridger/employee-skills-map",
  JOBS_LIBRARY: "/jobs-library",
  LEARNING_CATALYST: "/learning-catalyst",
  TALENT_MOBILITY: "/talent-mobility",
};

// ─── Proficiency bounds ───────────────────────────────────────────────────────

export const MIN_PROFICIENCY = 0;
export const MAX_PROFICIENCY = 5;

// ─── Pagination ───────────────────────────────────────────────────────────────

export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = ["10", "20", "30"];

// ─── Modal dimensions ─────────────────────────────────────────────────────────

export const WARNING_MODAL_WIDTH = 480;
export const CONDITIONAL_MODAL_WIDTH = 480;
